export const ACCESS_TOKEN = 'AccessToken'
export const USER_EMAIL = 'user_email'
